var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0833 14.25H19.8471C19.3183 14.25 18.8227 13.9856 18.5298 13.5454L16.3036 10.2062C16.0091 9.76442 15.5151 9.5 14.9863 9.5H7.91667C6.16708 9.5 4.75 10.9171 4.75 12.6667V30.0833C4.75 31.8329 6.16708 33.25 7.91667 33.25H30.0833C31.8329 33.25 33.25 31.8329 33.25 30.0833V17.4167C33.25 15.6671 31.8329 14.25 30.0833 14.25Z",
    stroke: "#006AFF",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 26.125L15.8333 23.75",
    stroke: "#006AFF",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 22.1667L18.2083 26.125",
    stroke: "#006AFF",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 9.5V7.91667C7.9165 6.16708 9.33359 4.75 11.0832 4.75H26.9165C28.6661 4.75 30.0832 6.16708 30.0832 7.91667V14.25",
    stroke: "#006AFF",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfile);
export default __webpack_public_path__ + "static/media/uploadfile.fe29b8624337c50b44d2206ae2356995.svg";
export { ForwardRef as ReactComponent };